import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Navigate, Link } from "react-router-dom";
import MainWrapper from "../../MainWrapper";
import { Table } from "react-bootstrap";
import Icon from "react-icons-kit";
import { ic_arrow_back } from "react-icons-kit/md";
import Loader from "../../layouts/Loader";
import axios from "axios";
import { API_URL } from "../../../config";

// Drill-down list opened from the "Estimate Ready" widget: floorplans Estimating
// marked ready that Sales hasn't started an order for. Respects the role's dataScope
// ("self" => only the logged-in salesperson's floorplans).
const EstimateReady = ({
  auth: { auth, isAuthenticated },
  Admin: { userMenuList },
}) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  // Client-side, per-column text filters (case-insensitive substring match).
  const [filters, setFilters] = useState({
    propertyName: "",
    floorplanName: "",
    storeName: "",
    salesPersonName: "",
  });
  const handleFilterChange = (e) =>
    setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const token = auth && auth[0] ? auth[0].token : null;
  const userId = auth && auth[0] ? auth[0].userId : null;
  const salesPersonId = auth && auth[0] ? auth[0]?.salesPersonId : null;
  let tmpUserId = userId;
  if(salesPersonId){
    tmpUserId = salesPersonId
  }
  const dashboard =
    userMenuList && userMenuList[0] ? userMenuList[0].dashboard : null;
  const dataScope = (dashboard && dashboard.dataScope) || "all";
  const scopedSalesPersonId = dataScope === "self" ? tmpUserId : null;

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    const params = {};
    if (scopedSalesPersonId) params.salesPersonId = scopedSalesPersonId;
    axios
      .get(`${API_URL}/Dashboard/api/Dashboard/EstimateReady`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((res) => {
        const data = Array.isArray(res.data)
          ? res.data
          : (res.data && res.data.result) || [];
        // Newest Estimate Ready first: sort by when the estimate first became
        // ready (falling back to dateReady), descending.
        const readyTime = (r) => {
          const t = new Date(r.firstEstimateReadyOn || r.dateReady).getTime();
          return isNaN(t) ? 0 : t;
        };
        const sorted = [...data].sort((a, b) => readyTime(b) - readyTime(a));
        setRows(sorted);
      })
      .catch((err) => {
        console.warn("Could not load Estimate Ready list:", err.message);
      })
      .finally(() => setLoading(false));
  }, [token, scopedSalesPersonId]);

  if (!isAuthenticated) return <Navigate to="/login" />;

  const formatDate = (value) => {
    if (!value) return "—";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "—";
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const year = d.getFullYear();
    return `${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day}-${year}`;
  };

  // Timestamp (date + time) for the CubiCasa Done / estimate-ready moment.
  const formatDateTime = (value) => {
    if (!value) return "—";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "—";
    let hours = d.getHours();
    const minutes = d.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${formatDate(value)} ${hours}:${minutes < 10 ? "0" + minutes : minutes} ${ampm}`;
  };

  // Elapsed days since the estimating team completed the floorplan.
  const formatDays = (days) =>
    days == null ? "—" : `${days} ${days === 1 ? "day" : "days"}`;

  const matchFilter = (value, query) =>
    (value || "").toString().toLowerCase().includes(query.trim().toLowerCase());
  const filteredRows = rows.filter(
    (r) =>
      matchFilter(r.propertyName, filters.propertyName) &&
      matchFilter(r.floorplanName, filters.floorplanName) &&
      matchFilter(r.storeName, filters.storeName) &&
      matchFilter(r.salesPersonName, filters.salesPersonName)
  );

  return (
    <Fragment>
      <MainWrapper>
        <Loader loading={loading}>
          <div className="container">
            <div className="sub-header mt-5 mb-3">
              <h2>Estimate Ready</h2>
              <Link className="btn btn-primary me-1" to="/dashboard">
                <Icon icon={ic_arrow_back} />Back
              </Link>
            </div>
            <Table bordered hover responsive>
              <thead>
                <tr style={{ whiteSpace: "nowrap" }}>
                  <th>CubiCasa Ready</th>
                  <th>Estimate Ready On</th>
                  <th>Days Since Ready</th>
                  <th>Property Name</th>
                  <th>Floorplan Name</th>
                  <th style={{ width: "105px" }}>Store Name</th>
                  <th>Salesperson</th>
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="propertyName"
                      placeholder="Filter"
                      value={filters.propertyName}
                      onChange={handleFilterChange}
                    />
                  </th>
                  <th>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="floorplanName"
                      placeholder="Filter"
                      value={filters.floorplanName}
                      onChange={handleFilterChange}
                    />
                  </th>
                  <th style={{ width: "105px" }}>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="storeName"
                      placeholder="Filter"
                      value={filters.storeName}
                      onChange={handleFilterChange}
                    />
                  </th>
                  <th>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="salesPersonName"
                      placeholder="Filter"
                      value={filters.salesPersonName}
                      onChange={handleFilterChange}
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredRows.length > 0 ? (
                  filteredRows.map((r, i) => (
                    <tr key={i}>
                      <td>{formatDateTime(r.cubiCasaReadyOn)}</td>
                      <td>{formatDateTime(r.firstEstimateReadyOn)}</td>
                      <td>{formatDays(r.daysSinceEstimateReady)}</td>
                      <td>{r.propertyName || "—"}</td>
                      <td>{r.floorplanName || "—"}</td>
                      <td>{r.storeName || "—"}</td>
                      <td>{r.salesPersonName || "—"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">
                      {rows.length > 0
                        ? "No floorplans match the filters."
                        : "No floorplans waiting for selection."}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Loader>
      </MainWrapper>
    </Fragment>
  );
};

const mapStateToProps = ({ auth, Admin }) => ({ auth, Admin });

export default connect(mapStateToProps)(EstimateReady);